import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import LoadingButton from 'src/components/UI/LoadingButton';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { deleteAmbassadorAction } from 'src/redux/actions/ambassadorActions';

const DeleteAmbassadorDialog = () => {
  const dispatch = useAppDispatch();
  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteAmbassador]) {
        return state.dialog[DIALOGS.deleteAmbassador];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.delete_ambassador] === FORM_STATUS.processing,
  );

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteAmbassador }));
  };

  const handleOk = () => {
    if (payload) {
      dispatch(deleteAmbassadorAction(payload));
    }
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-contact"
      open={opened}>
      <DialogTitle id="deleting-contact">Deleting ambassador</DialogTitle>
      <DialogContent dividers>
        Are you sure you want to delete that ambassador?
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary" disabled={processing}>
          {t(lang, 'misc.no')}
        </Button>
        <LoadingButton onClick={handleOk} color="primary" loading={processing}>
          {t(lang, 'misc.yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAmbassadorDialog;
